import { apiFetch, toQuery } from './client';
import type { Activity, Paginated } from '$lib/types';

export const activityApi = {
  forProject: (projectId: number, params?: { page?: number; per_page?: number }) =>
    apiFetch<Paginated<Activity>>(`/projects/${projectId}/activity${toQuery(params)}`)
};
